<script>
  import Modal from '@components/shared/modal.svelte';
  
  let { presence = $bindable(null), role = "viewer", onUpdate, onDelete } = $props();
  
  let open = $derived(presence !== null );
  let title = $derived(presence ? presence.user.name : null);
  let editable = $derived(presence && (role === "admin" || (role === "manager" && !presence.user.vet)));
  
  let period = $state("");
  let notes = $state("");

  $effect(() => {
    notes = presence?.notes || "";
    period = presence?.period || "";
  });
  
  function handleUpdate(e) {
    e.preventDefault();
    if (!editable) return;
    const id = presence.id;
    presence = null;
    onUpdate?.(id, { notes, period });
  }

  function handleDelete() {
    if (!editable) return;
    const id = presence.id;
    presence = null;
    onDelete?.(id);
  }
</script>

<Modal open={open} onClose={() => presence = null} {title}>

  <form id="presence-form" onsubmit={handleUpdate}>

    {#if !editable}
      <div class="app-message notice">
        <i class="fal fa-info-circle"></i>
        Ce formulaire est en lecture seule.
      </div>
    {/if}
    
    <div class="form-items">

      <div class="form-item col-span-12">
        <label for="clinic">Clinic</label>
        <input readonly type="text" id="clinic" value={presence.clinic.name} />
      </div>

      
      <div class="form-item col-span-6">
        <label for="date">Date</label>
        <input readonly type="text" id="date" value={new Date(presence.date).toLocaleDateString()} />
      </div>

      <div class="form-item col-span-6">
        <label for="period">Période</label>
        <select id="period" bind:value={period} disabled={!editable}>
          {#each presence.available_slots as slot}
            {@const label = slot === "am" ? "Matin" : slot === "pm" ? "Après-midi" : "Journée"  }
            <option value={slot}>{label}</option>
          {/each}
        </select>
      </div>

      <div class="flex items-center relative col-span-12 w-[102%] mx-[-1%]">
        <mark class="p-2 bg-transparent ml-3 text-xs text-gray-500 z-[2]">Autres informations</mark>
        <span class="absolute left-0 bg-gray-200/80 w-full h-px"></span>
      </div>

      <div class="form-item col-span-12">
        <label for="notes">Notes</label>
        <textarea name="notes" id="notes" bind:value={notes} readonly={!editable}></textarea>
      </div>
      
    </div>

  </form>

  {#snippet footerButtons()}
    {#if editable}
      <button type="button" class="button outline-danger" disabled={!presence.deletable} onclick={handleDelete}>Supprimer</button>
      <button class="button submit" form="presence-form">Mettre à jour</button>
    {/if}
  {/snippet}
  
</Modal>
